module.exports = __webpack_public_path__ + "static/media/faq1x2.6f5566f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq1x2.png
// module id = 576
// module chunks = 1